import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from 'react-router-dom'

import NeedHelp from '../../components/need-help'

import { getSS, setSS, renderDate, loadIndexPage } from '../../helpers'

const Thanks: React.FC = (props: any) => {

  const navigate = useNavigate()
  const params = useParams()
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const [ dataLayerInitialPush4, setDataLayerInitialPush4 ] = useState(getSS('dataLayerInitialPush4'))
  const url = membership_form.private_form ? 'private/' + params.url : params.url
  let membership = getSS('membership')
  const wakehurstMembership = getSS('membership')?.selected_membership?.wakehurst_membership

  if (!membership.amount) {
    loadIndexPage(navigate, url)
  }

  useEffect(() => {
    document.title = 'Thank you - ' + (window as any).KEW.collections.membership_form[0].meta_title
  })

  useEffect(() => {

    if (!dataLayerInitialPush4) {
      const formType = membership_form.form_type === 'standard' ? 'new' :
        membership_form.form_type === 'upgrade' ? 'upgrade' :
        membership_form.form_type === 'renewal' ? 'renewal' :
        membership_form.form_type === 'ingarden' ? 'new' :
        membership_form.form_type === 'daypass' ? 'new' : 'new';

      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: 'purchase',
        ecommerce: {
          currency: 'GBP',
          value: membership.amount,
          transaction_id: membership.id,
          payment_type: `${membership.payment_method}`,
          items: [{
            item_name: `Membership - ${membership_form.name} - ${membership.selected_membership.value}`,
            item_id: `${membership_form.campaigncode}`,
            price: membership.amount,
            item_brand: `${membership.selected_membership.wakehurst_membership ? 'Wakehurst' : 'Kew'}`,
            item_category: `Membership - ${membership.selected_membership.value}`,
            item_category2: `${formType}`,
            item_category3: `Gift Aid - ${membership.optins_giftaid ? 'Yes' : 'No'}`,
            quantity: 1
          }]
        }
      });
      setSS('dataLayerInitialPush4', true)
      setDataLayerInitialPush4(true)
    }
  }, [membership, membership_form.campaigncode, membership_form.form_type, membership_form.name, dataLayerInitialPush4])

  useEffect(() => {
    document.body.classList.add('thankyou')
    document.body.style.backgroundImage = `url(${membership_form.thankyou_page_background})`
    return ()=> {
      loadIndexPage(navigate, url)
    }
  }, [membership_form.thankyou_page_background, navigate, url])

  // useEffect(() => {
  //   (window as any).addEventListener('beforeunload', function (e: any) {
  //     alert('unload')
  //     e.preventDefault();
  //     loadIndexPage(history, url)
  //   })
  // }, [])

  return (
    <>
      { membership &&
        <form name="membershipForm">
          <div className="row intro">
            <div className="large-12 columns box">
              <div className="intro-copy">
                <h1>{membership_form.thank_you_page_title}</h1>
              </div>
            </div>
          </div>
          <div className="row intro-divider hide-for-small"></div>
          <div className="row box thanks">
            <div className="row">
              <div className="medium-7 columns">
                <div className="mobile-image show-for-small-only">
                  <img src={membership_form.thank_you_mobile_image} alt={membership_form.thank_you_image_alt} />
                  { membership_form.thank_you_image_credit &&
                    <span className="credit">{membership_form.thank_you_image_credit}</span>
                  }
                </div>
                { membership.payment_type === 'Single' &&
                  <div dangerouslySetInnerHTML={{ __html: membership_form.single_thank_you_intro}}></div>
                }
                { membership.payment_type === 'Regular' &&
                  <div dangerouslySetInnerHTML={{ __html: membership_form.regular_thank_you_intro}}></div>
                }
                <div className="donation-details">
                  <p>{membership_form.form_type !== 'upgrade' &&<span>Membership type:</span>} {membership_form.form_type === 'upgrade' &&<span>Membership upgraded to:</span>} <b>{getSS('membership').selected_membership.title}</b></p>
                  <p>Membership {membership_form.form_type === 'upgrade' &&<span>upgrade</span>} fee: <b>£{(membership.amount).toFixed(2)}</b></p>
                  <p>Payment reference: <b>{membership.id}</b></p>
                </div>
                { !wakehurstMembership &&
                  <>
                    <img src="/assets/default/images/giftaid.png" alt="Gift Aid Logo" className="logo"/>
                    { membership.optins_giftaid &&
                      <p>Thank you too for signing up to Gift Aid, which means your donation will go even further in supporting our work.</p>
                    }
                    { !membership.optins_giftaid &&
                      <p>Your membership fee and any donations you make would be worth an extra 25% to us if we were able to claim Gift Aid on it. Please consider making a Gift Aid declaration by speaking to our Supporter Care team using the details below.</p>
                    }
                    { membership.payment_type === 'Single' &&
                      <div className="divider"></div>
                    }
                  </>
                }
                <p>Congratulations again - and thank you. Your support is vital to us.</p>
              </div>
              <div className="medium-5 large-4 columns">
                <div className="mobile-divider show-for-small-only"></div>
                <NeedHelp />
                { membership_form.private_form && membership_form.form_type === 'standard' && (membership_form.direct_debit_enabled || membership_form.card_reader_enabled) &&
                  <button className="btn-cta go" id="reset-form" onClick={() => loadIndexPage(navigate, url)}>Reset form</button>
                }
              </div>
            </div>
            <div className="row">
              <div className="medium-12 columns">
                { getSS('membership').payment_type === 'Regular' &&
                  <>
                    <div className="ddGuarantee clearfix box">
                      <div className="row">
                        <div className="large-12 columns">
                          <section id="ddInstruction">
                            <span className="icon-dd-logo"></span>
                            <h2 className="dd">Direct Debit Instruction</h2>
                            <p>Please print off and retain for your records</p>
                            <div className="row">
                              <div className="large-6 columns">
                                <p className="strong"><span className="larger block">The Royal Botanic Gardens, Kew</span>Royal Botanic Gardens, Kew, Richmond, Surrey TW9 3AE</p>
                                <p className="nbm"> Name(s) of Account Holder(s):</p>
                                <p className="strong">{membership.bank_account_account_name}</p>
                                <p className="nbm">Bank / building society Account Number:</p>
                                <p className="strong">{membership.bank_account_number_redacted}</p>
                                <p className="nbm">Branch Sort Code:</p>
                                <p className="strong">{membership.bank_account_sort_code}</p>
                                <p className="nbm">Name and full postal address of your bank or building society:</p>
                                <p className="strong">
                                  <span className="address-key validated-bank-details">
                                    <span>{membership.validated_dd_bank_name}</span>
                                    <span>{membership.validated_dd_bank_address1}</span>
                                    <span>{membership.validated_dd_bank_address2}</span>
                                    <span>{membership.validated_dd_bank_town}</span>
                                    <span>{membership.validated_dd_bank_postcode}</span>
                                  </span>
                                </p>
                              </div>
                              <div className="large-6 columns">
                                <p>Instruction to your bank or building society to pay by Direct Debit</p>
                                <p className="strong">Service user number: {membership.bacs_sun}</p>
                                <p className="strong">Instruction to your bank or building society:</p>
                                <p className="strong">Please pay Royal Botanic Gardens, Kew Direct Debits from the account detailed in this Instruction subject to the safeguards assured by the Direct Debit Guarantee. I understand that this instruction may remain with Royal Botanic Gardens, Kew and, if so, details will be passed electronically to my bank/building society.</p>
                                <p className="strong">Date: {renderDate(membership.date_created)}</p>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                    <div className="ddGuarantee clearfix box">
                      <div className="large-12 columns">
                        <p>The Royal Botanic Gardens, Kew will set up a Direct Debit from the account detailed in this instruction subject to the safeguards assured by the Direct Debit Guarantee.</p>
                        <span className="icon-dd-logo"></span>
                        <h2 className="dd">The Direct Debit Guarantee</h2>
                        <ul>
                          <li>This Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.</li>
                          <li>If there are any changes to the amount, date or frequency of your Direct Debit Royal Botanic Gardens, Kew will notify you 5 working days in advance of your account being debited or as otherwise agreed. If you request Royal Botanic Gardens, Kew to collect a payment, confirmation of the amount and date will be given to you at the time of the request.</li>
                          <li>If an error is made in the payment of your Direct Debit, by Royal Botanic Gardens, Kew or your bank or building society you are entitled to a full and immediate refund of the amount paid from your bank or building society. If you receive a refund you are not entitled to, you must pay it back when Royal Botanic Gardens, Kew asks you to.</li>
                          <li>In the event Royal Botanic Gardens, Kew are unsuccessful collecting a payment, we may attempt a second collection within 31 days.</li>
                          <li>You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify us on +44 (0)208 332 3248.</li>
                        </ul>
                      </div>
                    </div>
                  </>
                }
                { !membership_form.private_form &&
                  <div className="share-container">
                    <p>Please consider sharing news of your new membership with your family, friends and colleagues.</p>
                    <a className="btn-share fb" target="_blank" rel="noreferrer" href={`https://www.facebook.com/sharer/sharer.php?u=${membership_form.facebook_share}`}><span className="icon-fb">Facebook</span></a>
                    <a className="btn-share tw" target="_blank" rel="noreferrer" href={`http://twitter.com/intent/tweet?text=${membership_form.twitter_share}`}><span className="icon-tw">Twitter</span></a>
                  </div>
                }
              </div>
            </div>
          </div>
        </form>
      }
    </>
  );
};

export default Thanks;